import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { getPartnerDashboard } from '../services/partnerDashboard';
import { partnerDashboardQueryKeys } from './query-keys';

export const usePartnerDashboardQuery = () => {
  const { isPartner } = useAuth();

  return useQuery({
    queryKey: partnerDashboardQueryKeys.all,
    enabled: isPartner,
    queryFn: async () => {
      const result = await getPartnerDashboard();
      if (!result.success) {
        throw new Error(result.message || 'Failed to load partner dashboard');
      }
      return result.data;
    },
  });
};
